<script>
import Input from './Input.vue'

export default {
	components: {
		Input,
	},
	data: () => ({
		fields: [
			{
				label: '文本输入框',
				props: 'field1',
				type: 'input',
				placeholder: '请输入文本',
				required: true,
				value: '',
			},
			{
				label: '数字输入框',
				props: 'field2',
				type: 'input',
				placeholder: '请输入数字',
				rule: 'number',
				required: false,
				value: 0,
			},
			{
				label: '日期选择器',
				props: 'field3',
				type: 'datepicker',
				placeholder: '请输入日期',
				value: null,
			},
			{
				label: '单项选择器',
				props: 'field4',
				type: 'picker',
			},
		],
	}),

	render(h) {
		return (
			<div class='custom-form'>
				{this.fields.map((item) => (
					<div class='form-item'>
						<label>{item.label}</label>                                    
					</div>
                ))}
                
			</div>
		)
	},
}
</script>

<style lang="less" scoped>
.form-item {
	border-bottom: 1px solid #e2e2e2;
	padding: 5px 0;
	// label {
	// 	font-size: 14px;
	// 	color: #333333;
	// }

	[placeholder] {
		color: #999999;
		font-size: 13px;
	}
	.cell {
		height: 40px;
		line-height: 40px;
	}
}
</style>
